export const conversionCategories = {
  number: {
    title: 'Number Systems',
    primaryBadge: {
      text: 'Base Conversions',
      color: 'emerald'
    },
    secondaryBadge: 'Multiple Bases',
    tertiaryBadge: 'Scientific Notation',
    description: 'Convert between binary, decimal, hex, and other number systems'
  },
  weight: {
    title: 'Weight Conversion',
    primaryBadge: {
      text: 'Mass Units',
      color: 'purple'
    },
    secondaryBadge: 'SI & Imperial',
    tertiaryBadge: 'Precision',
    description: 'Convert between kilograms, pounds, ounces, and other mass units'
  },
  length: {
    title: 'Length Conversion',
    primaryBadge: {
      text: 'Distance Units',
      color: 'blue'
    },
    secondaryBadge: 'Metric & Imperial',
    tertiaryBadge: 'Precision',
    description: 'Convert between meters, feet, inches, and other length units'
  },
  power: {
    title: 'Power Conversion',
    primaryBadge: {
      text: 'Power Units',
      color: 'red'
    },
    secondaryBadge: 'Electrical & Mechanical',
    tertiaryBadge: 'Energy Rate',
    description: 'Convert between watts, horsepower, and other power units'
  },
  voltage: {
    title: 'Voltage Conversion',
    primaryBadge: {
      text: 'Electrical Units',
      color: 'amber'
    },
    secondaryBadge: 'Potential Difference',
    tertiaryBadge: 'Circuit Analysis',
    description: 'Convert between volts, millivolts, and other voltage units'
  },
  energy: {
    title: 'Energy Conversion',
    primaryBadge: {
      text: 'Energy Units',
      color: 'green'
    },
    secondaryBadge: 'Work & Power',
    tertiaryBadge: 'Conservation',
    description: 'Convert between joules, calories, kWh, and other energy units'
  },
  'electric-charge': {
    title: 'Electric Charge Conversion',
    primaryBadge: {
      text: 'Charge Units',
      color: 'yellow'
    },
    secondaryBadge: 'Coulomb System',
    tertiaryBadge: 'Electrical',
    description: 'Convert between coulombs, ampere-hours, and elementary charge units'
  },
  frequency: {
    title: 'Frequency Conversion',
    primaryBadge: {
      text: 'Wave Units',
      color: 'indigo'
    },
    secondaryBadge: 'Periodic Motion',
    tertiaryBadge: 'Oscillation',
    description: 'Convert between hertz, kilohertz, and other frequency units'
  },
  temperature: {
    title: 'Temperature Conversion',
    primaryBadge: {
      text: 'Thermal Units',
      color: 'orange'
    },
    secondaryBadge: 'Temperature Scales',
    tertiaryBadge: 'Heat Energy',
    description: 'Convert between Celsius, Fahrenheit, Kelvin, and other scales'
  },
  color: {
    title: 'Color Conversion',
    primaryBadge: {
      text: 'Color Models',
      color: 'rose'
    },
    secondaryBadge: 'RGB & CMYK',
    tertiaryBadge: 'Digital Color',
    description: 'Convert between RGB, HEX, HSL, CMYK, and other color models'
  },
  resistance: {
    title: 'Resistance Conversion',
    primaryBadge: {
      text: 'Electrical Units',
      color: 'cyan'
    },
    secondaryBadge: 'Ohm System',
    tertiaryBadge: 'Circuit Analysis',
    description: 'Convert between ohms, kiloohms, and other resistance units'
  },
  image: {
    title: 'Image Conversion',
    primaryBadge: {
      text: 'Image Formats',
      color: 'teal'
    },
    secondaryBadge: 'Digital Media',
    tertiaryBadge: 'Resolution',
    description: 'Convert between JPG, PNG, WebP, and other image formats'
  }
}; 